import React from "react"

import { MarkovModelFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchMarkovModel {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: MarkovModelFilters
    onFilter: (filters: MarkovModelFilters) => void
}

const MarkovModelSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchMarkovModel) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default MarkovModelSearch
